import * as React from "react";
import { PlatformPageDialog } from "@platform/style";
import { WorkItemTabs } from "./WorkItemTabs";

export function WorkItems() {
  return (
    <PlatformPageDialog
      title={"Work Items"}
      eventName={"WorkItems"}
      showPageHeader={true}
      showCloseIcon={false}
      keepMounted={false}
    >
      <WorkItemTabs />
    </PlatformPageDialog>
  );
}
